import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {SharedModule} from '../shared.module';

import {HeaderComponent} from './header/header.component';
import {SearchComponent} from './search/search.component';
import {SideNavComponent} from './side-nav/side-nav.component';
import {FooterComponent} from './footer/footer.component';

import {SideNavDirective} from '../directives/side-nav.directive';
import {ThemeConstantService} from '../services/theme-constant.service';
import {TopProgressBarComponent} from '@shared/template/top-progress-bar/top-progress-bar.component';

@NgModule({
    exports: [
        HeaderComponent,
        SearchComponent,
        SideNavComponent,
        SideNavDirective,
        FooterComponent,
        TopProgressBarComponent
    ],
    imports: [
        SharedModule,
    ],
    declarations: [
        HeaderComponent,
        SearchComponent,

        SideNavComponent,
        SideNavDirective,
        FooterComponent,
        TopProgressBarComponent
    ],
    providers: [
        ThemeConstantService,
    ]
})

export class TemplateModule { }
